// Foundations
import { Pipe, PipeTransform } from '@angular/core';

// Extensions
import { unit } from 'mathjs';

@Pipe({
  name: 'convertUnit'
})
export class UnitConversionPipe implements PipeTransform {

  transform(value: number, unit1: string, unit2: string): number {
    return Math.round(Math.round(unit(value, unit1).toNumber(unit2) * 10) / 10);
  }

}
